import { useNavigate, useLocation } from 'react-router-dom';

interface NavItem {
  path: string;
  label: string;
  icon: string;
  isUpload?: boolean;
}

const navItems: NavItem[] = [
  { path: '/', label: '홈', icon: 'ri-home-4-line' },
  { path: '/albums', label: '앨범', icon: 'ri-gallery-line' },
  { path: '/upload', label: '업로드', icon: 'ri-add-line', isUpload: true },
  { path: '/notifications', label: '알림', icon: 'ri-notification-3-line' },
  { path: '/profile', label: '프로필', icon: 'ri-user-3-line' },
];

export default function BottomNav() {
  const navigate = useNavigate();
  const location = useLocation();

  const isActive = (path: string) => {
    if (path === '/') return location.pathname === '/';
    return location.pathname.startsWith(path);
  };

  return (
    <nav className="fixed bottom-0 left-0 right-0 z-50 bg-background-50 border-t border-background-200/70 pb-[env(safe-area-inset-bottom)]" style={{ minHeight: '72px' }}>
      <div className="flex items-end justify-around h-[72px] px-2 pb-2 max-w-lg mx-auto relative">
        {navItems.map((item) => {
          if (item.isUpload) {
            return (
              <button
                key={item.path}
                onClick={() => navigate(item.path)}
                className="relative flex flex-col items-center justify-center -mt-4 cursor-pointer group"
                aria-label={item.label}
              >
                <div className={`w-14 h-14 rounded-2xl flex items-center justify-center transition-all duration-300 ${
                  isActive(item.path)
                    ? 'bg-accent-500 text-background-50 scale-110'
                    : 'bg-foreground-900 text-background-50 hover:bg-accent-500'
                }`}>
                  <i className={`${item.icon} text-2xl`}></i>
                </div>
              </button>
            );
          }
          const active = isActive(item.path);
          return (
            <button
              key={item.path}
              onClick={() => navigate(item.path)}
              className={`flex flex-col items-center justify-center gap-0.5 cursor-pointer transition-all duration-200 px-3 py-1 rounded-xl ${
                active ? 'text-accent-500' : 'text-foreground-400 hover:text-foreground-600'
              }`}
              aria-label={item.label}
            >
              <div className="w-6 h-6 flex items-center justify-center">
                <i className={`${item.icon} text-xl ${active ? '' : ''}`}></i>
              </div>
              <span className="text-[11px] font-medium whitespace-nowrap">{item.label}</span>
            </button>
          );
        })}
      </div>
    </nav>
  );
}